import React from "react";

import { CloseGreyIcon } from "../../assets/icons";
import ReactDOM from "react-dom";

interface ConfirmModalProps {
    title: string;
    description?: string;
    informationConfirm: boolean;
    onResult: (confirmed: boolean) => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ title, informationConfirm, description, onResult }) => {

    return (
        ReactDOM.createPortal(
        <section className="modal-section confirm">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">{title}</div>
                                <div className="description-text">{description}</div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={() => onResult(false)} />
                            </div>
                        </div>

                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={() => onResult(false)}>
                                <div>Otkaži</div>
                            </div>

                            {informationConfirm ? (
                                <div className="button-primary medium" onClick={() => onResult(true)}>
                                    <div>Potvrdi</div>
                                </div>
                            ) : (
                                <div className="button-primary red-bg" onClick={() => onResult(true)}>
                                    <div>Obriši</div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </section>
        , document.body)

    );
};

export default ConfirmModal;